import { DatePicker } from "antd";
import React, { useState } from "react";
const Birthday = ({
  birthday,
  setBirthday,
  calculateAge,
  userStoreUser,
  handleNext,
  isSmallScreen,
}) => {
  const [birthdayError, setBirthdayError] = useState("");
  const handleChangeBirthday = (date) => {
    setBirthdayError("");
    setBirthday(date);
  };
  const handleSubmitBirthday = (e) => {
    e.preventDefault();
    if (birthday !== "") {
      let modifiedBirthday = new Date(Date.parse(birthday)).toLocaleDateString(
        "en-us"
      );
      const age = calculateAge(modifiedBirthday);
      if (age < 13) {
        console.log(
          "You must be at least 13 years old to sign in to Lookflock"
        );
        setBirthdayError(
          "You must be at least 13 years old to sign in to Lookflock!"
        );
        return;
      } else {
        userStoreUser.birthday = modifiedBirthday;
        userStoreUser.isVerified = true;
        handleNext();
      }
    } else {
      setBirthdayError("Please enter your birthday first!");
    }
  };
  return (
    <>
      <div
        className="text-center mb-4"
        style={{
          lineHeight: "0.5rem",
          paddingRight: isSmallScreen ? "2rem" : "4rem",
        }}
      >
        <h3
          style={{
            fontFamily: "Playfair Display",
            fontWeight: 600,
            fontSize: isSmallScreen ? "1.5rem" : "2rem",
          }}
        >
          Enter your date of birth
        </h3>
        <p
          className="px-3"
          style={{
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: isSmallScreen ? "0.85rem" : "1.1rem",
            lineHeight: "1.5rem",
          }}
        >
          To help keep Lookflock safe, we now require your date of birth.
        </p>
      </div>
      <form
        className="d-flex flex-column"
        style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
        onSubmit={(e) => handleSubmitBirthday(e)}
      >
        <div className="d-flex flex-column align-items-start gap-1">
          <label
            htmlFor="birthdayInput"
            style={{
              color: "black",
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: "0.8rem",
            }}
          >
            Date of birth
          </label>
          <DatePicker
            value={birthday}
            format={{
              format: "MM/DD/YYYY",
              type: "mask",
            }}
            // placeholder={birthday.toLocaleDateString("en-us")}
            onChange={(date) => handleChangeBirthday(date)}
            className="form-control rounded-3"
            required
          />
        </div>
        <div
          className="text-danger text-start mb-2 ms-1"
          style={{ fontSize: "0.85rem" }}
        >
          {birthdayError}
        </div>
        <button
          disabled={!birthday}
          type="submit"
          className="btn btn-primary flex-grow-1 rounded-3"
        >
          Next
        </button>
      </form>
    </>
  );
};

export default Birthday;
